// extracted by mini-css-extract-plugin
export default {"broadcastPanel":"BroadcastPanel_broadcastPanel__BEJNj","marqueeText":"BroadcastPanel_marqueeText__eTMm-"};